__turbopack_context__.v({
  "className": "archivo_e78d8916-module__zDGR2q__className",
});
